
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

interface RequestDetailsCardProps {
  notes: string;
  niche: string;
  linkType: string;
  drMin: number;
  daMin: number;
}

const RequestDetailsCard = ({ notes, niche, linkType, drMin, daMin }: RequestDetailsCardProps) => {
  return (
    <Card className="shadow-sm">
      <CardHeader className="pb-3">
        <CardTitle>Request Details</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="prose prose-sm max-w-none">
          <p className="whitespace-pre-line text-gray-700">{notes}</p>
        </div>
        
        <div className="mt-6 grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-4 gap-2 md:gap-3">
          <div className="flex flex-col items-center p-2 sm:p-3 bg-primary/5 rounded-lg hover:bg-primary/7 transition-colors">
            <div className="text-xs font-medium text-gray-500 mb-1">Niche</div>
            <div className="text-center font-semibold text-sm truncate w-full">{niche}</div>
          </div>
          <div className="flex flex-col items-center p-2 sm:p-3 bg-primary/5 rounded-lg hover:bg-primary/7 transition-colors">
            <div className="text-xs font-medium text-gray-500 mb-1">Link Type</div>
            <div className="text-center font-semibold text-sm truncate w-full">{linkType}</div>
          </div>
          <div className="flex flex-col items-center p-2 sm:p-3 bg-primary/5 rounded-lg hover:bg-primary/7 transition-colors">
            <div className="text-xs font-medium text-gray-500 mb-1">Min DR</div>
            <div className="text-center font-semibold text-sm">{drMin}+</div>
          </div>
          <div className="flex flex-col items-center p-2 sm:p-3 bg-primary/5 rounded-lg hover:bg-primary/7 transition-colors">
            <div className="text-xs font-medium text-gray-500 mb-1">Min DA</div>
            <div className="text-center font-semibold text-sm">{daMin}+</div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default RequestDetailsCard;
